import { COLUMN_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';

export const columns = [
    {
        dataField: 'LotSerial',
        caption: 'Serial',
        minWidth: COLUMN_SIZE.sm1,
        width: COLUMN_SIZE.lg0,
        fixed: true,
        allowSorting: true,
        allowEditing: false,
    },
    {
        dataField: 'Bin',
        caption: 'Bin',
        minWidth: COLUMN_SIZE.sm1,
        width: COLUMN_SIZE.lg0,
        fixed: true,
        allowSorting: true,
        allowEditing: false,
    },
    {
        dataField: 'BinType',
        caption: 'Bin type',
        minWidth: COLUMN_SIZE.sm1,
        width: COLUMN_SIZE.lg0,
        fixed: true,
        allowSorting: true,
        allowEditing: false,
    },
];
